import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';

import { getAffList } from '../../store/reducers/affiliateReducer';
import { Button } from '@mui/material';

const CopyToClipBoard = ({cell})=>{
  const [copied, setCopied] = useState(false);

        const onCopyText = () => {
          setCopied(true);
          setTimeout(() => {
            setCopied(false);
          }, 2000);
        };

        function updateClipboard(newClip) {
          navigator.clipboard.writeText(newClip).then(() => {
            setCopied(true)
            onCopyText()
          }, () => {
            console.log("Copy unsuccessful")
          });
        }

        return (<Button variant="text" onClick={(e)=>{updateClipboard(cell)}}>{copied? "Copied!":"Copy URL"}</Button>)
}

const List = () => {

  const data = useSelector(state=>state.affiliate.list)
  const dispatch = useDispatch();

  useEffect(()=>{
      dispatch(getAffList());
  },[dispatch])

  const columns = [
    {
      dataField: "percentage",
      text: "Commission Percentage",
      formatter: (cell, row, rowIndex)=>{
        return `${cell}`
      }
    },
    {
      dataField: "repeat_percent",
      text: "Commission Percentage (repeat)",
      formatter: (cell, row, rowIndex)=>{
        return `${cell}`
      }
    },
    {
      dataField: "code",
      text: "Code",
      formatter: (cell)=>{
        return (
          <div style={{overflow: "auto",textOverflow: "ellipsis"}}>{cell}</div>
        )
      }
    },
    {
      dataField: "pushed_leads",
      text: "Pushleads",
    },
    {
      dataField: "consumed_by_count",
      text: "Conversions"
    },
    {
      dataField: "url",
      text: "URL",
      formatter: (cell, row, rowIndex)=>{
        return <CopyToClipBoard cell={cell}/>
      }
    }
  ];
    
  return (
    <div id="aff-code-list-table">
      {data && Array.isArray(data) && data.length?<BootstrapTable keyField="id" data={data} columns={columns}/>:false}
    </div>
  )
}

export default List
